'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntlRedux = require('react-intl-redux');

var _messages = require('utils/messages');

var _languages = require('utils/languages');

var _utilityFunctions = require('utils/utilityFunctions');

var _pacomo = require('utils/pacomo');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deFlag = require('theme/img/de.svg');
var enFlag = require('theme/img/en.svg');
var frFlag = require('theme/img/fr.svg');

var allOptions = [{ value: 'en', label: 'English' }, { value: 'de', label: 'Deutsch' }, { value: 'fr', label: 'Français' }];

var options = allOptions.filter(function (opt) {
    return _languages.allowedLanguages.includes(opt.value);
});

var flags = {
    en: enFlag,
    de: deFlag,
    fr: frFlag
};

var flagOption = function flagOption(props) {

    var handleMouseDown = function handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        props.onSelect(props.option, event);
    };

    var handleMouseEnter = function handleMouseEnter(event) {
        props.onFocus(props.option, event);
    };

    var handleMouseMove = function handleMouseMove(event) {
        if (props.isFocused) return;
        props.onFocus(props.option, event);
    };

    return _react2.default.createElement(
        'div',
        {
            className: props.className,
            onMouseDown: handleMouseDown,
            onMouseEnter: handleMouseEnter,
            onMouseMove: handleMouseMove,
            title: props.option.title },
        _react2.default.createElement('img', { src: flags[props.option.value], width: '20', height: '20', alt: props.option.value }),
        ' ',
        _react2.default.createElement(
            'span',
            null,
            props.children
        )
    );
};

var Flag = function Flag(_ref) {
    var value = _ref.value;

    return _react2.default.createElement('img', { className: 'grex-LangPicker-flag', src: flags[value], width: '20', height: '20', alt: value });
};

var LangPicker = function LangPicker(_ref2) {
    var locale = _ref2.locale,
        bookingId = _ref2.bookingId,
        dispatch = _ref2.dispatch;


    var updateLocale = function updateLocale(e) {
        if (_languages.allowedLanguages.includes(e.value)) {
            dispatch((0, _reactIntlRedux.updateIntl)({
                locale: e.value,
                messages: _messages.allMessages[e.value]
            }));
            (0, _utilityFunctions.setLanguageCookie)(bookingId + '-g2g-lang', e.value);
        }
    };

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Flag, { value: locale }),
        _react2.default.createElement(_reactSelect2.default, {
            name: 'langPickerSelect',
            value: locale,
            optionComponent: flagOption,
            options: options,
            onChange: updateLocale,
            clearable: false,
            className: 'isOpen',
            searchable: false
        })
    );
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        locale: state.intl.locale,
        // needed for language cookie
        bookingId: state.bookingMeta.id
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(LangPicker));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/LangPicker.js
// module id = 1298
// module chunks = 0